module.exports = __webpack_public_path__ + "img/seconDkill_boxBanner.87b97ad1.png";